export const NUMERIC_TYPES = {
    FACTOR: "factor",
    RATIO: "ratio",
    PRICE: "price",
    AMOUNT: "amount"
};

export const TYPE_FORMAT = {
    factor: { min: 2, max: 4 },
    ratio: { min: 2, max: 2 },
    price: { min: 2, max: 2 },
    amount: { min: 0, max: 0 }
};
